import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BlogPost from './BlogPost';
import SidebarWidgets from '../Common/SidebarWidgets';
import { api } from '../../services/api';
import { useContentList } from '../../hooks/useContent';

function BlogInner() {
    const [currentPage, setCurrentPage] = useState(1);
    const { items: posts, loading, error } = useContentList(() => api.getBlogPosts({ per_page: 100 }), []);
    const postsPerPage = 6;
    const totalPages = Math.ceil(posts.length / postsPerPage) || 1;

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <section className="th-blog-wrapper space-top space-extra-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        {loading && <p className="text-center">Loading posts...</p>}
                        {error && <p className="text-center text-danger">{error}</p>}
                        {!loading && !error && !posts.length && (
                            <p className="text-center">No blog posts published yet.</p>
                        )}
                        {currentPosts.map((data) => (
                            <BlogPost
                                key={data.id}
                                blogID={data.id}
                                blogImage={data.image || data.bannerImg}
                                blogTitle={data.title}
                                authorName={data.author_name}
                                publishedAt={data.published_at}
                                location={data.location}
                                excerpt={data.excerpt}
                            />
                        ))}
                        {posts.length > postsPerPage && (
                            <div className="th-pagination">
                                <ul>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li key={i}>
                                            <Link
                                                className={currentPage === i + 1 ? 'active' : ''}
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handlePageChange(i + 1);
                                                }}
                                            >
                                                {i + 1}
                                            </Link>
                                        </li>
                                    ))}
                                    {currentPage < totalPages && (
                                        <li>
                                            <Link
                                                className="next-page"
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handlePageChange(currentPage + 1);
                                                }}
                                            >
                                                Next <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <SidebarWidgets categoryType="blog" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlogInner;
